export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: 12,
    minHeight: 'calc(100vh - 260px)',
    margin: '0 auto',
    maxWidth: 360,
  },
  iconWrapper: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.05)',
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    color: '#333',
  },
  description: {
    fontSize: 13,
    color: '#888',
    marginBottom: 8,
  },
};
